export default __webpack_public_path__ + "static/media/Mobile-Checklist-Preflight.18b05d85.png";